
function pad2(n: number): string {
  return n < 10 ? "0" + n : String(n);
}

export function todayIso(): string {
  const d = new Date();
  return d.getFullYear() + "-" + pad2(d.getMonth() + 1) + "-" + pad2(d.getDate());
}

export function nowHm(): string {
  const d = new Date();
  return pad2(d.getHours()) + ":" + pad2(d.getMinutes());
}

export function trimJam(jam: any): string {
  if (!jam) return "";
  return String(jam).substring(0, 5);
}

export function trimTanggal(tgl: any): string {
  if (!tgl) return "";
  return String(tgl).substring(0, 10);
}

export function labelObservasi(row: any): string {
  if (!row) return "";
  const tgl = trimTanggal(row.tanggal_observasi);
  const jam = trimJam(row.jam_observasi);
  if (!tgl) return jam || "";
  const d = new Date(tgl + "T00:00:00");
  const tglLabel = isNaN(d.getTime())
    ? tgl
    : d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
  return jam ? tglLabel + " " + jam : tglLabel;
}
